import React from 'react';
import { Tooltip } from 'react-tooltip';
import { useStore } from '../../../../../../store';
import { PrimaryInvoiceActions } from './PrimaryInvoiceActions';
import { SecondaryInvoiceActions } from './SecondaryInvoiceActions';
import { isAnEmptyObject } from '../../../../utils';

export const InvoicePageActions = () => {
  const selectedInvoice = useStore(state => state.selectedInvoice);
  if (isAnEmptyObject(selectedInvoice)) return null;
  return (
    <div className='flex justify-between pt-[12px]'>
      <PrimaryInvoiceActions status={selectedInvoice.status} />
      <SecondaryInvoiceActions status={selectedInvoice.status} />
      <Tooltip id='invoice-actions-tooltip' place='bottom' className='invoice-tooltip-styles' />

    </div>
  );
};
